import { createApi } from '@reduxjs/toolkit/query/react';
import { HttpStatus } from '../../common/enums/HttpStatus';
import { createBaseQuery } from './utils/createBaseQuery';
import { IQuestionnaire } from '../../common/interfaces/Questionnaire.interface';
import { Status } from '../../common/enums/Status';

export const questionnaireApi = createApi({
  reducerPath: 'QuestionnaireApi',
  baseQuery: createBaseQuery('/onboarding/questionnaires'),
  tagTypes: ['Questionnaire'],
  endpoints: (builder) => ({
    fetchQuestionnaireList: builder.query<
      { code: HttpStatus; data: IQuestionnaire[] },
      void
    >({
      query: () => '/list',
      providesTags: (result) =>
        result
          ? [
              ...result.data.map((q) => ({
                type: 'Questionnaire' as const,
                id: q.id,
              })),
              { type: 'Questionnaire' as const, id: 'LIST' },
            ]
          : [{ type: 'Questionnaire' as const, id: 'LIST' }],
    }),

    updateQuestionnaireStatus: builder.mutation<
      IQuestionnaire,
      { id: string; data: { status: Status } }
    >({
      query: ({ id, data }) => ({
        url: `/${id}/status`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: (result) =>
        result ? [{ type: 'Questionnaire' as const, id: result.id }] : [],
    }),

    createQuestionnaire: builder.mutation<
      IQuestionnaire,
      Partial<IQuestionnaire>
    >({
      query: (newQuestionnaire) => ({
        url: '',
        method: 'POST',
        body: newQuestionnaire,
      }),
      invalidatesTags: [{ type: 'Questionnaire', id: 'LIST' }],
    }),
  }),
});

// Export hooks for the API
export const {
  useFetchQuestionnaireListQuery,
  useCreateQuestionnaireMutation,
  useUpdateQuestionnaireStatusMutation,
} = questionnaireApi;
